import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { ApolloLink, Observable } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { HttpLink } from 'apollo-link-http'

import { logInfo } from 'main/util/paymentMethod/common'

const lego = window.lego

const request = async (operation: any) => {
  const token = localStorage.getItem('access_token')
  operation.setContext({
    headers: {
      authorization: token,
    },
  })
}

const requestLink = new ApolloLink(
  (operation, forward: any) =>
    new Observable(observer => {
      let handle: any
      Promise.resolve(operation)
        .then(o => request(o))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) handle.unsubscribe()
      }
    }),
)

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ networkError }) => {
      if (networkError) {
        logInfo('Apollo Network Error', { networkError })
        // TODO - fix CORS? or other issue with ELI/access_token
        // localStorage.removeItem('access_token')
      }
    }),
    requestLink,
    new HttpLink({
      uri: `${lego.config.DOMAIN}/graphql`,
      credentials: 'include',
    }),
  ]),
  cache: new InMemoryCache(),
})

export default client
